import { Operation } from 'hooks/store/types';
import { ActionTypes, resetAdminUserPassword } from 'store/account/admin';
import { useEffect } from 'react';
import { useDispatch, usePrevious } from 'hooks/utils';
import { useTranslation } from 'hooks/store';
import { useActivity } from 'hooks/store/utils/useActivity';
import { useAlerts } from 'hooks/ui';

export function useAdminUserPasswordReset(): Operation {
	const dispatch = useDispatch();
	const { translate } = useTranslation();
	const { setNotification } = useAlerts();

	const [{ loading, error }] = useActivity(ActionTypes.ADMIN_RESET_USER_PASSWORD);

	const wasLoading = usePrevious(loading);
	useEffect(() => {
		if (wasLoading && !loading && !error) {
			setNotification({
				message: translate(({ admin }) => admin.users.notifications.resetPassword)
			});
		}
	}, [loading, error]);

	function handler() {
		dispatch(resetAdminUserPassword());
	}

	return [{ loading, error }, handler];
}
